import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties, ReactNode } from "react";
import { Container } from "react-bootstrap";
import { sContent } from "src/styles/sContent.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  children?: ReactNode;
  fluid?: ("sm" | "md" | "lg" | "xl" | "xxl" | "full") | null | undefined;
  verticalSpace?: "none" | "sm" | "nm" | "md" | "lg";
  id?: string | null;
};

function ContentSection({
  style,
  className,
  children,
  fluid,
  verticalSpace,
  id,
}: Props) {
  return (
    <Container
      style={style}
      className={composeClassNames([
        sContent,
        `content`,
        verticalSpace && `vspace-${verticalSpace}`,
        className,
      ])}
      // @ts-ignore
      fluid={fluid}
      id={id}
    >
      {children}
    </Container>
  );
}

export default ContentSection;
